import { useEffect, useState } from "react";
import { usePostHog } from "posthog-js/react";

/** PostHog never answers a project over its flag quota, so no page waits longer. */
const WAIT_LIMIT_MS = 4000;

/**
 * True once PostHog has answered (or failed) this page's flags request, so an
 * experiment can wait for its arm instead of showing control first. Flags kept
 * from an earlier visit do not count; an uninitialised client (server render,
 * tests) has no flags coming.
 */
export default function useFlagsSettled() {
  const posthog = usePostHog();
  const [settled, setSettled] = useState(
    () => !posthog?.__loaded || posthog.featureFlags.hasLoadedFlags
  );

  useEffect(() => {
    if (settled) return;
    if (!posthog?.__loaded) {
      setSettled(true);
      return;
    }
    const settle = () => setSettled(true);
    const timer = setTimeout(settle, WAIT_LIMIT_MS);
    const unsubscribe = posthog.onFeatureFlags(settle);
    return () => {
      clearTimeout(timer);
      unsubscribe();
    };
  }, [posthog, settled]);

  return settled;
}
